import {ProviderModel} from './ProviderModel';

export class ScartiConsuntivoChargesModel {
  id: number;
  numAnnoMese: number;
  regionCod: string;
  localCustomerCod: string;
  contractCod: string;
  resourcesUnitCod: string;
  providerCod: string;
  errors: string;
  numAnnoMeseRif: number;
  designedServiceCod: string;
  billedMonth: string;
  resourcesUnitName: string;
  numAnnoMeseAcceptance: number;
  residualMonth: number;
  percUse: number;
  applicableRate: string;
  actualVolumes: number;
  charge: string;

  constructor(id?: number,
              numAnnoMese?: number,
              regionCod?: string,
              localCustomerCod?: string,
              contractCod?: string,
              resourcesUnitCod?: string,
              errors?: string,
              providerCod?: string,
              designedServiceCod?: string,
              numAnnoMeseRif?: number,
              billedMonth?: string,
              resourcesUnitName?: string,
              numAnnoMeseAcceptance?: number,
              residualMonth?: number,
              percUse?: number,
              applicableRate?: string,
              actualVolumes?: number,
              charge?: string) {
    this.id = id;
    this.numAnnoMese = numAnnoMese;
    this.regionCod = regionCod;
    this.localCustomerCod = localCustomerCod;
    this.contractCod = contractCod;
    this.resourcesUnitCod = resourcesUnitCod;
    this.designedServiceCod = designedServiceCod;
    this.providerCod = providerCod;
    this.errors = errors;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.billedMonth = billedMonth;
    this.resourcesUnitName = resourcesUnitName;
    this.numAnnoMeseAcceptance = numAnnoMeseAcceptance;
    this.residualMonth = residualMonth;
    this.percUse = percUse;
    this.applicableRate = applicableRate;
    this.actualVolumes = actualVolumes;
    this.charge = charge;
  }
}
